var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumCustomBus = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.511 10.31V5.975A2.367 2.367 0 0 0 22.138 3.6H7.879a2.378 2.378 0 0 0-2.373 2.375v4.335A2.377 2.377 0 0 0 3.6 12.633v.954c0 .78.641 1.422 1.42 1.422h.486v7.126c0 1.144.814 2.115 1.906 2.323v.52c0 .78.64 1.422 1.42 1.422h1.906c.78 0 1.42-.642 1.42-1.422v-.468h5.7v.468c0 .78.642 1.422 1.421 1.422h1.906c.78 0 1.42-.642 1.42-1.422v-.52a2.377 2.377 0 0 0 1.906-2.323v-7.126h.468c.78 0 1.42-.642 1.42-1.422v-.954c.018-1.144-.796-2.098-1.888-2.323zM9.785 5.507h10.447c.78 0 1.42.642 1.42 1.422 0 .78-.64 1.422-1.42 1.422H9.785c-.78 0-1.42-.642-1.42-1.422 0-.78.64-1.422 1.42-1.422zm-1.42 14.738c0-.78.64-1.422 1.42-1.422.78 0 1.42.642 1.42 1.422 0 .78-.64 1.422-1.42 1.422-.78.017-1.42-.625-1.42-1.422zm10.446 0c0-.78.641-1.422 1.421-1.422s1.42.642 1.42 1.422c0 .78-.64 1.422-1.42 1.422-.78.017-1.42-.625-1.42-1.422zm2.374-3.33H8.832c-.78 0-1.42-.64-1.42-1.42v-4.752c0-.78.64-1.421 1.42-1.421h12.353c.78 0 1.42.641 1.42 1.421v4.751c.018.78-.623 1.422-1.42 1.422z",
    fill: "#1E2969",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumCustomBus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-custom-bus.a2cb82ebef1b4820d31ffad42c33110a.svg";